<section class="companies-page">
    <header class="companies-heading">
        <span class="companies-heading-icon"><img src="assets/media/svg/mis-empresas.svg" alt="" width="32" height="32"></span>
        <div>
            <h1>Mis empresas</h1>
            <nav aria-label="Ruta de navegación"><a routerLink="/dashboard">Portal Defontana</a><span> / </span><a routerLink="/dashboard">Dashboard</a><span> / </span><span aria-current="page">Mis empresas</span></nav>
        </div>
    </header>
    <p class="companies-subtitle">Administra las empresas asociadas a tu cuenta</p>
    <div class="companies-toolbar">
        <form class="companies-search" role="search" (submit)="$event.preventDefault(); applyFilter()">
            <input #searchInput type="search" maxlength="50" autocomplete="off" aria-label="Buscar empresas" placeholder="Buscar" [value]="searchTerm" (input)="searchTerm = searchInput.value; onSearchInput()">
            <button type="submit" aria-label="Buscar empresas"><mat-icon aria-hidden="true">search</mat-icon></button>
        </form>
        <button class="associate-button" type="button" (click)="AsociarEmpresa()">Asociar Suite <mat-icon aria-hidden="true">add</mat-icon></button>
    </div>
    <article class="companies-table-card" aria-label="Listado de empresas" [attr.aria-busy]="appStateService.loading">
        <div class="companies-table-scroll">
            <table mat-table [dataSource]="appStateService.GetListcompany && appStateService.GetListcompany.companyList || []" aria-label="Empresas asociadas a tu cuenta">
                <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef>Empresa</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="company-name-cell">
                            <span class="company-row-icon"><img src="assets/media/svg/mis-empresas.svg" alt="" width="24" height="24"></span>
                            <span class="company-name">{{element.companyName}} <small class="expired-label" *ngIf="RemoverEmpresaEstilo(element.expirationDate)">(Expirada)</small></span>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="menu">
                    <th mat-header-cell *matHeaderCellDef>Acciones</th>
                    <td mat-cell *matCellDef="let element">
                        <mat-menu #companyMenu="matMenu">
                            <button mat-menu-item [disabled]="RemoverEmpresa(element)" (click)="DeshabilitarEmpresa(element)"><mat-icon aria-hidden="true">close</mat-icon>Deshabilitar empresa</button>
                        </mat-menu>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="companyMenu" [attr.aria-label]="'Acciones de ' + element.companyName"><mat-icon aria-hidden="true">more_vert</mat-icon></button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr *matNoDataRow>
                    <td colspan="2" class="companies-empty" role="status">{{appStateService.loading ? 'Cargando empresas…' : 'No se encontraron empresas.'}}</td>
                </tr>
            </table>
        </div>
        <app-list-paginator [listado]="3" [pageSizeOptions]="pageSizeOptions"></app-list-paginator>
    </article>
</section>
